import { useFeatureValue } from '@growthbook/growthbook-react'
import { useGrowthbookFeature } from './useGrowthbook'
import storageService from '../services/storageService'
import { useMemo } from 'react'

export const useIsReferAFriendEnabled = () => {
  const { userIds } = useGrowthbookFeature('fe_igp_override_raf_unavailability', { userIds: [] })
  const isReferAFriendEnabled = useFeatureValue('fe_igp_refer_a_friend')

  const isATestUser = useMemo(() => {
    const user = storageService.getUser()
    return userIds?.includes(user?.id)
  }, [userIds])

  const isEnabled = isReferAFriendEnabled || isATestUser

  return isEnabled
}
